<template>
 <no-mortgage-data-upload-page v-if="isAllowedToUpload" />
 <no-mortgage-alternatives-page v-else />
</template>

<script>
import { mapGetters } from 'vuex';
import NoMortgageDataUploadPage from './NoMortgageDataUploadPage.vue';
import NoMortgageAlternativesPage from './NoMortgageAlternativesPage.vue';

export default {
  name: 'NoMortgageDataAlternativesPage',
  components: {
    NoMortgageDataUploadPage,
    NoMortgageAlternativesPage,
  },
  data() {
    return {
      loadingIntercom: false,
      uploadingFile: false,
    };
  },
  computed: {
    ...mapGetters('featureFlags', ['uploadMortgageData']),
    ...mapGetters('session', ['householdName']),
    ...mapGetters('mortgages', ['hasMortgageData']),
    isAllowedToUpload() {
      return this.uploadMortgageData && !this.hasMortgageData;
    },
  },
};
</script>

<style scoped lang="scss">
@import "~@riseupil/base-ui/src/scss/riseup-colors";
@import "~@riseupil/base-ui/src/scss/spacings";

.sticky-cta-page {
  background: $riseup_beige;

  .image-header-page {
    background: $riseup_beige;

    .header-text {
      text-align: right;
    }

    .cards-container {
      background-color: $riseup_white;
    }

    .yellow-text {
      color: $riseup_yellow;
    }

    .card-text {
      color: $riseup_dark_green;
      text-align: center;
    }

    .image-container {
      display: flex;
      justify-content: center;
    }

    .footer-text {
      color: $riseup_black;
      text-align: center;
      text-decoration: underline;
      cursor: pointer;
    }

    .mortgage-btn {
      ::v-deep .button-titles {
        white-space: nowrap;
      }
    }

    .center-text {
      text-align: center;
    }

    .or-text {
      color: $riseup_black;
      font-size: 14px;
    }

    .url-blue {
      color: $riseup_blue;
    }
  }
}

</style>
